import React, { Component } from 'react'
import NavLink from './NavLink'
import { toPersianDigit } from '../../helpers/nums'

const styles = {
  badge: { fontSize: 14, color: 'red', margin: 0 }
}

export default class MenuItem extends Component {
  render() {
    const {
      label,
      iconClass,
      url,
      withPendingOrderCount,
      pendingOrders,
      ...rest
    } = this.props

    const shouldShowBadge = withPendingOrderCount === true && pendingOrders > 0

    return (
      <NavLink to={url} {...rest}>
        <i className={iconClass} aria-hidden="true" />

        <span>{label}</span>

        {shouldShowBadge && (
          <span style={styles.badge}>{` (${toPersianDigit(pendingOrders)}) `}</span>
        )}
      </NavLink>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/MenuItem.js